const stories = [
  {
    before: "ストラップ付きの靴しか履けなかった",
    after: "初めてプレーンパンプスを普通に履けました",
    name: "T.K さん（34歳）",
    detail: "足幅が細く、パンプスがいつも脱げてしまうのが悩みでした。足タイプを診断してもらったら、細幅タイプとわかり、自分に合う靴を選んでもらいました。",
    tag: "細幅タイプ",
  },
  {
    before: "夕方になると脱ぎたくて仕方なかった",
    after: "仕事帰りにそのまま食事に行けるようになった",
    name: "M.S さん（38歳）",
    detail: "長時間履くと前滑りして痛くなるのが当然だと思っていました。インソール調整と靴選びで、夕方でも快適に過ごせるように。",
    tag: "前滑りタイプ",
  },
  {
    before: "おしゃれな靴は全部諦めていた",
    after: "外反母趾でもヒールが履けるって知らなかった",
    name: "Y.A さん（41歳）",
    detail: "外反母趾があるから、かわいい靴は諦めていました。骨格に合った靴幅と素材を選ぶことで、痛みなく履けるヒールに出会えました。",
    tag: "外反母趾対応",
  },
  {
    before: "サイズが小さくてどこにも靴がなかった",
    after: "22cmでもこんなにおしゃれな選択肢があるんですね",
    name: "R.N さん（29歳）",
    detail: "22cmの小さいサイズはどこも子供っぽい靴しかなく困っていました。サイズ展開が豊富で、大人の靴が見つかって感動しました。",
    tag: "小さいサイズ",
  },
];

export default function BeforeAfterSection() {
  return (
    <section className="bg-[#FAFAF8] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-4">
            <span
              className="bg-[#F5F0EA] text-[#B8895A] text-xs px-3 py-1 rounded-full whitespace-nowrap"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              お客様の変化
            </span>
          </div>
          <h2
            className="text-3xl md:text-4xl font-bold text-[#1C1917] leading-snug"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            "人生が変わった"
            <br />
            靴の履き方。
          </h2>
        </div>

        {/* Masonry-style grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {stories.map((story, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-6 border border-[#F0EBE3] flex flex-col gap-4"
            >
              {/* Tag */}
              <span
                className="self-start bg-[#1C1917] text-white text-[10px] px-2.5 py-1 rounded-full whitespace-nowrap"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                {story.tag}
              </span>

              {/* Before */}
              <div className="bg-[#F5F0EA] rounded-xl p-4">
                <p
                  className="text-[#78716C] text-[10px] tracking-widest mb-2 uppercase"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  Before
                </p>
                <p
                  className="text-[#44403C] text-sm font-medium leading-snug"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  "{story.before}"
                </p>
              </div>

              {/* Arrow */}
              <div className="flex items-center justify-center">
                <div className="w-8 h-8 flex items-center justify-center bg-[#E8C99A]/20 rounded-full">
                  <i className="ri-arrow-down-line text-[#B8895A] text-sm" />
                </div>
              </div>

              {/* After */}
              <div className="bg-[#1C1917] rounded-xl p-4">
                <p
                  className="text-[#E8C99A] text-[10px] tracking-widest mb-2 uppercase"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  After
                </p>
                <p
                  className="text-white text-sm font-medium leading-snug"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  "{story.after}"
                </p>
              </div>

              {/* Detail */}
              <p
                className="text-[#78716C] text-xs leading-loose"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                {story.detail}
              </p>

              {/* Name */}
              <div className="flex items-center gap-2 mt-auto pt-2 border-t border-[#F0EBE3]">
                <div className="w-7 h-7 flex items-center justify-center bg-[#F5F0EA] rounded-full flex-shrink-0">
                  <i className="ri-user-smile-line text-[#B8895A] text-xs" />
                </div>
                <span className="text-[#44403C] text-xs font-medium" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                  {story.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}